import * as React from "react";
import type { SVGProps } from "react";
const SvgCompanyNews = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M45.988 28.21c.34.337.342.885.005 1.225L19.124 56.51a.866.866 0 0 1-1.23-1.22l26.869-27.076a.866.866 0 0 1 1.225-.005Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M17.79 28.318a.866.866 0 0 1 1.225-.005l27.07 26.869a.866.866 0 1 1-1.22 1.23l-27.07-26.87a.866.866 0 0 1-.005-1.224Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M10.902 1.732A4.328 4.328 0 0 0 6.574 6.06v51.88a4.328 4.328 0 0 0 4.328 4.328h42.197a4.328 4.328 0 0 0 4.328-4.328V6.06a4.328 4.328 0 0 0-4.328-4.328H10.901ZM4.842 6.06A6.06 6.06 0 0 1 10.901 0h42.197a6.06 6.06 0 0 1 6.06 6.06v51.88a6.06 6.06 0 0 1-6.06 6.06H10.901a6.06 6.06 0 0 1-6.06-6.06V6.06Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M47.692 8.323H16.314a3.248 3.248 0 0 0-3.248 3.248v7.202a3.248 3.248 0 0 0 3.248 3.249h31.378a3.248 3.248 0 0 0 3.248-3.249v-7.202a3.248 3.248 0 0 0-3.248-3.248Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M16.314 9.189a2.382 2.382 0 0 0-2.382 2.382v7.202a2.382 2.382 0 0 0 2.382 2.383h31.378a2.382 2.382 0 0 0 2.382-2.383v-7.202a2.382 2.382 0 0 0-2.382-2.382H16.314ZM12.2 11.57a4.114 4.114 0 0 1 4.114-4.114h31.378a4.114 4.114 0 0 1 4.114 4.114v7.202a4.114 4.114 0 0 1-4.114 4.115H16.314a4.114 4.114 0 0 1-4.114-4.115v-7.202Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M32 52.772c5.675 0 10.275-4.6 10.275-10.275 0-5.674-4.6-10.274-10.275-10.274-5.674 0-10.274 4.6-10.274 10.274 0 5.675 4.6 10.275 10.274 10.275Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M32 33.09a9.408 9.408 0 1 0 0 18.815 9.408 9.408 0 0 0 0-18.816Zm-11.14 9.407c0-6.152 4.988-11.14 11.14-11.14 6.153 0 11.141 4.988 11.141 11.14 0 6.153-4.988 11.14-11.14 11.14-6.153 0-11.14-4.987-11.14-11.14Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M25.09 42.498c0-.479.387-.867.866-.867h12.09a.866.866 0 1 1 0 1.733h-12.09a.866.866 0 0 1-.867-.866ZM27.076 38.818c0-.478.387-.866.866-.866h8.12a.866.866 0 0 1 0 1.732h-8.12a.866.866 0 0 1-.866-.866ZM27.076 46.176c0-.478.387-.866.866-.866h8.12a.866.866 0 1 1 0 1.732h-8.12a.866.866 0 0 1-.866-.866ZM17.514 28.825c0-.479.387-.866.866-.866h5.453a.866.866 0 1 1 0 1.732h-4.587v4.634a.866.866 0 0 1-1.732 0v-5.5ZM39.105 28.825c0-.479.387-.866.866-.866h5.453c.479 0 .866.387.866.866v5.5a.866.866 0 0 1-1.732 0v-4.634h-4.587a.866.866 0 0 1-.866-.866ZM18.38 49.529c.478 0 .866.388.866.866v4.64h4.587a.866.866 0 1 1 0 1.732H18.38a.866.866 0 0 1-.866-.867v-5.505c0-.478.387-.866.866-.866ZM45.48 49.529c.48 0 .867.388.867.866V55.9a.866.866 0 0 1-.866.867h-5.454a.866.866 0 1 1 0-1.733h4.588v-4.639c0-.478.387-.866.866-.866Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCompanyNews;
